import { useQuery } from '@tanstack/react-query'

import { responsibleMedicalRecordInstance } from '../..'

export function getResponsibleMedicalRecordForReviewQueryKey(id: string) {
  return ['responsibleMedicalRecordForReview', id]
}

export function useGetResponsibleMedicalRecordForReviewQuery({
  id,
  enabled
}: {
  id: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getResponsibleMedicalRecordForReviewQueryKey(id),
    queryFn: async () =>
      await responsibleMedicalRecordInstance.getResponsibleMedicalRecordForReview(
        { id }
      ),
    enabled
  })
}
